/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Passkey_Inactive_ProgramInputs */

const es_co2_error_passkey_inactive_program = /** @type {(inputs: Error_Passkey_Inactive_ProgramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El programa de esta llave está inactivo.`)
};

/**

* @param {Error_Passkey_Inactive_ProgramInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_passkey_inactive_program = /** @type {((inputs?: Error_Passkey_Inactive_ProgramInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Passkey_Inactive_ProgramInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_passkey_inactive_program(inputs)
});